import { StoreApi } from 'zustand'
import { createContext } from 'react'

export type AppointmentDate = {
  day: string
  date: string
  availableTimes: Array<{
    millis: number
    time: string
  }>
}

export type SelectedAppointmentTime = {
  day: string
  date: string
  time: string
  millis: number
}

export type SelectedSchedule =
  | { type: 'immediate' }
  | {
      type: 'scheduled'
      selected: SelectedAppointmentTime
    }

export interface CallArrangementContextType {
  availableDates: Array<AppointmentDate>
  selectedSchedule: SelectedSchedule | null
  immediateSlotAvailable: boolean

  onSelectSchedule: (selected: SelectedSchedule | null) => void
  onNext: () => void
}

type CallArrangementContextStore = StoreApi<CallArrangementContextType>
export const CallArrangementContext =
  createContext<CallArrangementContextStore | null>(null)
